import React from "react";

export const EmptyIcon = ({style = {}}) => {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" style={{width: 16, height: 16, fill: "white", margin: 3, ...style}}></svg>
}